import React from "react";
import VadiiWebsite from "./VadiiWebsite";

function App() {
  return <VadiiWebsite />;
}

export default App;
